<template>
  <div class="radial-chart-container" :class="{ condensed, selected: isSelected }">
    <apexchart
      type="radialBar"
      :height="sizeHeight"
      :width="sizeWidth"
      :options="chartOptions"
      :series="[percentage]">
    </apexchart>
    <!-- Usamos :style para forzar el color cuando está seleccionado -->
    <div
      class="score-text-bottom"
      :class="{ condensed: condensed }"
      :style="isSelected && !condensed ? 'color: #fff !important;' : '#222'"
    >
      {{ formatDisplayPercent(percentage) }}
    </div>
  </div>
</template>

<script>
import { formatPercent } from '@/utils/numberFormat'
export default {
  name: 'ApexRadialChart',
  props: {
    percentage: {
      type: Number,
      required: true,
      default: 0,
      validator: value => value >= 0 && value <= 100
    },
    sizeWidth: {
      type: Number,
      default: 160
    },
    sizeHeight: {
      type: Number,
      default: 180
    },
    status: {
      type: String,
      default: 'progress',
      validator: value => ['done', 'progress', 'justified', 'uncompleted'].includes(value)
    },
    condensed: {
      type: Boolean,
      default: false
    },
    isSelected: {
      type: Boolean,
      default: false
    }
  },
  methods: { formatDisplayPercent(value) { return formatPercent(value, this.$i18n.locale) } },
  computed: {
    chartOptions() {
      // Para 0%, mostrar track gris completo
      const trackColor = '#F4F4F4';

      return {
        chart: {
          type: 'radialBar',
          height: this.sizeHeight, // Usamos directamente el valor numérico
          width: this.sizeWidth,   // Usamos directamente el valor numérico
          offsetY: this.condensed ? -5 : -10,
          sparkline: {
            enabled: true
          }
        },
        plotOptions: {
          radialBar: {
            startAngle: -90,
            endAngle: 90,
            track: {
              background: trackColor,
              strokeWidth: '90%',
              margin: 0
            },
            dataLabels: {
              name: {
                show: false
              },
              value: {
                offsetY: 0,
                fontSize: this.condensed ? '12px' : '14px',
                show: false
              }
            },
            hollow: {
              size: this.condensed ? '70%' : '60%'
            }
          }
        },
        colors: this.percentage === 0 ? ['#F4F4F4'] : ['#4F9EA2'],
        fill: {
          type: 'solid'
        },
        labels: ['Progress'],
        stroke: {
          lineCap: 'round' // Cambiado de 'none' a 'round' para evitar posibles errores
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.radial-chart-container {
  position: relative;
  display: inline-block;
  width: v-bind(sizeWidth + 'px'); /* Usamos v-bind para establecer el ancho dinámico */
  height: v-bind(sizeHeight + 'px'); /* Usamos v-bind para establecer el alto dinámico */
}

.score-text-bottom {
  position: absolute;
  left: 50%;
  bottom: 8px;
  transform: translateX(-50%);
  font-size: 18px;
  font-weight: bold;
  color: #000000;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: $conden-bold;

  &.condensed {
    color: var(--color-black, #222) !important;
    font-size: 24px !important;
    font-style: normal !important;
    font-weight: 700 !important;
    line-height: normal !important;
    bottom: 0px;
    color: $color-black !important;
    .selected & {
      color: $color-black !important;
    }
  }

}
</style>
